import { c as _c } from "react/compiler-runtime";
import IconCheckRound from '@/components/assets/icon_check_round.svg';
import IconVerifiedBadge from '@/components/assets/icon_verified_badge.svg';
import { cn } from '@/lib/utils';
type VerifiedBadgeProps = {
  className?: string;
  isVerified?: boolean;
  variant?: 'badge' | 'check';
};
export default function VerifiedBadge(t0) {
  const $ = _c(5);
  const {
    className,
    variant: t1,
    isVerified
  } = t0;
  const variant = t1 === undefined ? "badge" : t1;
  if (!isVerified) {
    return null;
  }
  const Icon = variant === "check" ? IconCheckRound : IconVerifiedBadge;
  let t2;
  if ($[0] !== className) {
    t2 = cn("block size-4 shrink-0", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== Icon || $[3] !== t2) {
    t3 = <Icon className={t2} aria-label="Verified creator" />;
    $[2] = Icon;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}